module.exports = __webpack_public_path__ + "static/media/icons8-home.87fe339a.svg";